<script>
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";
import { UserMessageElementMixin } from "%/dynamic-component-editor/standard-components/user-message/user-message-element-mixin";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";

export default {
  name: "UserMessageAuthorName",
  elementPanelSettings: {
    displayName: "User Message Author Name",
    displayIcon: "text-alt",
    elementGroup: "User Messages",
  },
  extends: UrlElement,
  mixins: [UserMessageElementMixin],
  options: [
    StoryCardClickBehavior,
  ],
  computed: {
    label() {
      return this.entity.authorName;
    },
    computedHref() {
      return this.storyHref;
    },
  },
};
</script>
